import { connect } from "react-redux";
import { Actions } from "@/store/masterSearch/slice";
import loadable from "@loadable/component";

const SearchMobileNav = loadable(
  () =>
    import(
      /* webpackChunkName: "search-mobile-nav" */
      "."
    ),
  {
    ssr: false,
  }
);

const mDp = {
  openMapPopup: Actions.openMapPopup,
  closeMapPopup: Actions.closeMapPopup,
  toggleMap: Actions.toggleMap,
  toggleFilters: Actions.toggleFilters,
};
export default connect(null, mDp)(SearchMobileNav);
